<p>
  shipping-mechanisms works!
</p>
